import { type QueryKey } from '@tanstack/react-query';

export const authQueryKey = createQueryKey('auth', 'getAccessTokenSilently');
export const settingsQueryKey = createQueryKey('settings.json');
export const statsigUpdateUserQueryKey = createQueryKey('statsig', 'updateUser');

export function createQueryKey(...args: unknown[]) {
  return [...args] as QueryKey;
}
